import {
  GET_INVOICES_BY_ADMIN,
  GET_INVOICES_BY_ADMIN_SUCCESS,
  GET_INVOICES_BY_ADMIN_ERROR,
  UPDATE_INVOICE_BY_ADMIN,
  UPDATE_INVOICE_BY_ADMIN_SUCCESS,
  UPDATE_INVOICE_BY_ADMIN_ERROR,
  CREATE_RECEIPT_BY_ADMIN,
  CREATE_RECEIPT_BY_ADMIN_SUCCESS,
  CREATE_RECEIPT_BY_ADMIN_ERROR,
  GET_BILLING_REPORT_BY_ADMIN,
  GET_BILLING_REPORT_BY_ADMIN_SUCCESS,
  GET_BILLING_REPORT_BY_ADMIN_ERROR,
  DELETE_INVOICE_BY_ADMIN,
  DELETE_INVOICE_BY_ADMIN_SUCCESS,
  DELETE_INVOICE_BY_ADMIN_ERROR,
  EDIT_INVOICE_BY_ADMIN,
  EDIT_INVOICE_BY_ADMIN_SUCCESS,
  EDIT_INVOICE_BY_ADMIN_ERROR,
  GET_INVOICE_EVENTS_BY_ID,
  GET_INVOICE_EVENTS_BY_ID_SUCCESS,
  GET_INVOICE_EVENTS_BY_ID_ERROR,
  RESET_INVOICE_EVENTS_BY_ID,
  ROLLBACK_INVOICE_VERSION,
  ROLLBACK_INVOICE_VERSION_SUCCESS,
  ROLLBACK_INVOICE_VERSION_ERROR,
  RESET_ERROR,
  RESET_RECEIPT_TERMINAL_FORM,
  GET_RECEIPTS_INFO_BY_ADMIN,
  GET_RECEIPTS_INFO_BY_ADMIN_SUCCESS,
  GET_RECEIPTS_INFO_BY_ADMIN_ERROR
} from "./actionTypes";

/**
 * @param {object} payload { use_bill_com: <boolean> }
 */

export const resetError = () => ({
  type: RESET_ERROR
});

export const getInvoicesByAdmin = (payload) => ({
  type: GET_INVOICES_BY_ADMIN,
  payload: payload
});

export const getInvoicesByAdminSuccess = (invoices) => ({
  type: GET_INVOICES_BY_ADMIN_SUCCESS,
  payload: invoices
});

export const getInvoicesByAdminError = (error) => ({
  type: GET_INVOICES_BY_ADMIN_ERROR,
  payload: error
});

export const updateInvoiceByAdmin = (invoice) => ({
  type: UPDATE_INVOICE_BY_ADMIN,
  payload: invoice
});

export const updateInvoiceByAdminSuccess = (invoice) => ({
  type: UPDATE_INVOICE_BY_ADMIN_SUCCESS,
  payload: invoice
});

export const updateInvoiceByAdminError = (error) => ({
  type: UPDATE_INVOICE_BY_ADMIN_ERROR,
  payload: error
});

export const createReceiptByAdmin = (receipt) => ({
  type: CREATE_RECEIPT_BY_ADMIN,
  payload: receipt
});

export const createReceiptByAdminSuccess = (receipt) => ({
  type: CREATE_RECEIPT_BY_ADMIN_SUCCESS,
  payload: receipt
});

export const createReceiptByAdminError = (error) => ({
  type: CREATE_RECEIPT_BY_ADMIN_ERROR,
  payload: error
});

export const getBillingReportByAdmin = (params) => ({
  type: GET_BILLING_REPORT_BY_ADMIN,
  payload: params,
});

export const getBillingReportByAdminSuccess = (billingReport) => ({
  type: GET_BILLING_REPORT_BY_ADMIN_SUCCESS,
  payload: billingReport,
});

export const getBillingReportByAdminError = (error) => ({
  type: GET_BILLING_REPORT_BY_ADMIN_ERROR,
  payload: error,
});

export const deleteInvoiceByAdmin = (invoice) => ({
  type: DELETE_INVOICE_BY_ADMIN,
  payload: invoice
});

export const deleteInvoiceByAdminSuccess = (invoice) => ({
  type: DELETE_INVOICE_BY_ADMIN_SUCCESS,
  payload: invoice
});

export const deleteInvoiceByAdminError = (error) => ({
  type: DELETE_INVOICE_BY_ADMIN_ERROR,
  payload: error
});

export const editInvoiceByAdmin = (invoice) => ({
  type: EDIT_INVOICE_BY_ADMIN,
  payload: invoice
});

export const editInvoiceByAdminSuccess = (invoice) => ({
  type: EDIT_INVOICE_BY_ADMIN_SUCCESS,
  payload: invoice
});

export const editInvoiceByAdminError = (error) => ({
  type: EDIT_INVOICE_BY_ADMIN_ERROR,
  payload: error
});

export const getInvoiceEventsById = (invoice) => ({
  type: GET_INVOICE_EVENTS_BY_ID,
  payload: invoice
});

export const getInvoiceEventsByIdSuccess = (invoice) => ({
  type: GET_INVOICE_EVENTS_BY_ID_SUCCESS,
  payload: invoice
});

export const getInvoiceEventsByIdError = (error) => ({
  type: GET_INVOICE_EVENTS_BY_ID_ERROR,
  payload: error
});

export const rollbackInvoiceVersion = (invoice) => ({
  type: ROLLBACK_INVOICE_VERSION,
  payload: invoice
});

export const rollbackInvoiceVersionSuccess = (invoice) => ({
  type: ROLLBACK_INVOICE_VERSION_SUCCESS,
  payload: invoice
});

export const rollbackInvoiceVersionError = (error) => ({
  type: ROLLBACK_INVOICE_VERSION_ERROR,
  payload: error
});

export const resetInvoiceEventsByIdState = (error) => ({
  type: RESET_INVOICE_EVENTS_BY_ID,
  payload: error
});

export const resetReceiptTerminalForm = () => ({
  type: RESET_RECEIPT_TERMINAL_FORM
});

export const getReceiptsInfoByAdmin = (query_params, paginated) => {
  return {
  type: GET_RECEIPTS_INFO_BY_ADMIN,
  payload: query_params, 
  paginated: paginated
}};

export const getReceiptsInfoByAdminSuccess = (invoice, meta = {}) => ({
  type: GET_RECEIPTS_INFO_BY_ADMIN_SUCCESS,
  payload: invoice,
  meta,
});

export const getReceiptsInfoByAdminError = (error) => ({
  type: GET_RECEIPTS_INFO_BY_ADMIN_ERROR,
  payload: error
});
